export const scanAreaOptions = [
  {
    key: 'Green',

    text: 'Green',

    value: 'Green',
  },

  {
    key: 'Red',

    text: 'Red',

    value: 'Red',
  },

  {
    key: 'Neutral',

    text: 'Neutral',

    value: 'Neutral',
  },
];

export const defaultTextBoxValue = [
  {
    key: 'DisplayName',
    text: 'Display Name',
    value: 'displayName',
  },
  {
    key: 'TimeStamp',
    text: 'Time Stamp',
    value: 'timeStamp',
  },
  {
    key: 'DisplayNameWithTimeStamp',
    text: 'Display Name with TimeStamp',
    value: 'displayNameWithTimeStamp',
  },
  {
    key: 'Email',
    text: 'Email',
    value: 'email',
  },
  {
    key: 'User Name',
    text: 'User Name',
    value: 'username',
  },
  {
    key: 'Department Name',
    text: 'Department Name',
    value: 'departmentName',
  },
  //static for LVPCMS-AM
  {
    key: 'Branch',
    text: 'Branch',
    value: 'addressLine2',
  },
];
